import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { InternshipListListingModel, InternshipListGridParams } from 'common/models/page-models/Student Internship List/Internship Table Model/internship-list.model';
import { InternshipFilterModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-data.model';



@Injectable({
    providedIn: 'root'
})
export class InternshipListGridDataService extends GridDataService<InternshipListListingModel, InternshipFilterModel> {
    pageName = ''; // Store navPageType as pageName
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.IntershipListGrid, http, ss);
        // console.log("Internship Grid Service Caleed")
    }

    createInstance(): InternshipListListingModel {
        return new InternshipListListingModel();
    }

    override getDataParam(): string {
        return 'details';
    }

    override getGridParams(param): GridPostParams {
        let payload = {};
        
        if(param.year && [0,1,2,3,4,5,6].includes(param.studentInternshipStatus)){
            payload = {
                year: param.year,
                studentInternshipStatus: param.studentInternshipStatus,
            }
        } 
        // else if(param?.transferData){
        //     payload = param.transferData;
        // } 
        else{
            payload = {
                year: new Date().getFullYear().toString(),
                studentInternshipStatus: 0
            }
        }
        return payload;
    }

    // override modifyMultiModel(data) {
    //     const pageData = new InternshipFilterModel
    //     pageData.apiResData = data;
    //     console.log(data, 'apiRes---')
    //     return pageData;
    // }

    override modifyGridPostParams(queryParams: any): GridPostParams {
        // console.log(queryParams)
        // const params
        return this.getGridParams(queryParams);

    }

    getDeleteUrl() {
        return '';
    }
}
